// Header Menu
export const headerForSaleButton = "header-for-sale-button";
export const headerForRentButton = "header-for-rent-button";
export const headerProjectsButton = "header-projects-button";
export const headerOurServicesButton = "header-our-services-button";
export const headerRealEstateNewsButton = "header-real-estate-news-button";
export const headerMembershipButton = "header-membership-button";

// Our Services Menu Sub Items
export const ourServicesArsaDunyasiButton = "our-services-arsa-dunyasi-button";
export const ourServicesProjeRadariButton = "our-services-proje-radari-button";
export const ourServicesEmlakYatirimUzmaniButton = "our-services-emlak-yatirim-uzmani-button";
export const ourServicesJettasinButton = "our-services-jettasin-button";

// Membership Menu Sub Items
export const membershipLoginButton = "membership-login-button";
export const membershipIndividualButton = "membership-individual-button";
export const membershipCorporateButton = "membership-corporate-button";
